import React from "react";
import { Box, Card, Stack, Typography } from "@mui/material";

export const USER_AUTH_BACKGROUND =
  "radial-gradient(circle at 12% 12%, rgba(143, 189, 207, 0.34), transparent 34%), radial-gradient(circle at 88% 84%, rgba(195, 226, 214, 0.38), transparent 32%), linear-gradient(145deg, #f9fcfd 0%, #eef7fa 52%, #f7fbf9 100%)";

export const USER_AUTH_CARD_SX = {
  width: "100%",
  bgcolor: "rgba(255,255,255,0.94)",
  color: "#26383f",
  border: "1px solid rgba(71,91,99,0.12)",
  borderRadius: "20px",
  boxShadow: "0 24px 70px rgba(59, 88, 99, 0.13)",
  backdropFilter: "blur(14px)",
  overflow: "hidden",
  "& .MuiOutlinedInput-root": {
    bgcolor: "#fbfdfe",
    borderRadius: "12px",
  },
  "& .MuiButton-root": {
    minHeight: 44,
    borderRadius: "12px",
    fontWeight: 650,
  },
  "& .MuiButton-containedPrimary-root": {
    bgcolor: "#475b63",
    color: "#fff",
    boxShadow: "none",
    "&:hover": { bgcolor: "#34474f", boxShadow: "none" },
  },
};

export function UserAuthBrand({ compact = false, align = "center" }) {
  return (
    <Stack
      direction={compact ? "row" : "column"}
      spacing={compact ? 1.25 : 1}
      alignItems="center"
      justifyContent={align === "left" ? "flex-start" : "center"}
      textAlign="center"
    >
      <Box
        component="img"
        src="/logo.svg"
        alt="mhome.ai"
        sx={{ width: compact ? 40 : 68, height: compact ? 40 : 68 }}
      />
      <Box sx={{ textAlign: compact ? "left" : "center" }}>
        <Typography
          sx={{
            color: "#344b55",
            fontSize: compact ? 19 : 26,
            fontWeight: 700,
            letterSpacing: "-0.025em",
            lineHeight: 1.1,
          }}
        >
          mhome.ai
        </Typography>
        <Typography
          sx={{
            mt: 0.5,
            color: "#70848d",
            fontSize: compact ? 11 : 13,
            letterSpacing: "0.025em",
          }}
        >
          Orchestrate The Entire Home
        </Typography>
      </Box>
    </Stack>
  );
}

export function UserAuthShell({ children, maxWidth = 480, showBrand = false }) {
  return (
    <Box
      sx={{
        position: "relative",
        isolation: "isolate",
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        px: 2,
        py: { xs: 3, sm: 6 },
        color: "#26383f",
        background: USER_AUTH_BACKGROUND,
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          zIndex: -1,
          opacity: 0.42,
          backgroundImage:
            "linear-gradient(rgba(71,91,99,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(71,91,99,0.035) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
          maskImage:
            "linear-gradient(to bottom, rgba(0,0,0,0.7), transparent 88%)",
        },
      }}
    >
      <Stack spacing={3} sx={{ width: "100%", maxWidth }}>
        {showBrand && <UserAuthBrand />}
        {children}
      </Stack>
    </Box>
  );
}

export function UserAuthCard({
  children,
  contentSx = {},
  showBrand = true,
  sx = {},
  ...props
}) {
  return (
    <Card elevation={0} sx={{ ...USER_AUTH_CARD_SX, ...sx }} {...props}>
      {showBrand && (
        <Box
          sx={{
            px: { xs: 2.5, sm: 3 },
            py: 1.75,
            bgcolor: "rgba(247,251,252,0.82)",
            borderBottom: "1px solid rgba(71,91,99,0.1)",
          }}
        >
          <UserAuthBrand compact align="left" />
        </Box>
      )}
      <Box sx={contentSx}>{children}</Box>
    </Card>
  );
}
